import './App.css';
import Home from './views';
import 'antd/dist/antd.min.css';
import { Theme } from 'theme';
import { Provider } from 'react-redux';
import { store } from 'store/store';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Theme>
          <Home />
        </Theme>
      </Provider>
    </div>
  );
}

export default App;
